// extracted by mini-css-extract-plugin
export default {"Container":"Taken_Container__DicS0","table":"Taken_table__BxzLP","video-icon":"Taken_video-icon__I03BK","link-upload":"Taken_link-upload__PUGAN","progress":"Taken_progress__CEPfs"};